import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Logout() {
  const nav = useNavigate();
  useEffect(() => {
    // clear whatever you set on login
    localStorage.clear();

    // go to login, prevent back to dashboard
    nav("/login", { replace: true, state: { loggedOut: true } });
  }, [nav]);

  return null; // or a tiny spinner if you like
}
